import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpResponse } from '@angular/common/http';
import { CreateMagirusPositionGroupDto } from '../dto/create-magirus-position-group.dto';
import { UpdateMagirusPositionGroupDto } from '../dto/update-magirus-position-group.dto';
import { MagirusPositionGroupDto } from '../dto/magirus-position-group.dto';

@Injectable({
  providedIn: 'root'
})
export class MagirusPositionGroupService {
  private apiUrl = `${environment.apiUrl}/magirus-position-groups`;

  constructor(private http: HttpClient) { }

  /**
   * Create a new position group
   */
  createPositionGroup(dto: CreateMagirusPositionGroupDto): Observable<MagirusPositionGroupDto> {
    return this.http.post<MagirusPositionGroupDto>(`${this.apiUrl}`, dto);
  }

  /**
   * Get all position groups
   */
  getAllPositionGroups(): Observable<MagirusPositionGroupDto[]> {
    return this.http.get<MagirusPositionGroupDto[]>(`${this.apiUrl}`);
  }

  /**
   * Get all active position groups
   */
  getActivePositionGroups(): Observable<MagirusPositionGroupDto[]> {
    return this.http.get<MagirusPositionGroupDto[]>(`${this.apiUrl}/active`);
  }

  /**
   * Get a single position group by id
   */
  getPositionGroupById(id: number): Observable<MagirusPositionGroupDto> {
    return this.http.get<MagirusPositionGroupDto>(`${this.apiUrl}/${id}`);
  }

  /**
   * Update an existing position group
   */
  updatePositionGroup(id: number, dto: UpdateMagirusPositionGroupDto): Observable<MagirusPositionGroupDto> {
    return this.http.patch<MagirusPositionGroupDto>(`${this.apiUrl}/${id}`, dto);
  }

  /**
   * Delete a position group and return full HTTP response
   */
  deletePositionGroup(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { observe: 'response' });
  }
  
  /**
   * Rename a position group
   */
  renamePositionGroup(id: number, name: string): Observable<MagirusPositionGroupDto> {
    return this.http.patch<MagirusPositionGroupDto>(
      `${this.apiUrl}/${id}/rename`,
      { name }
    );
  }
}
